var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"disabled":_vm.disabled},on:{"click":_vm.copy}},[_c('v-list-item-title',[_vm._v(" クリップボードにコピー ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }